export default "__VITE_ASSET__DJP_u_gi__"